import { dataCloudUploadSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCloudUploadSolid = /*#__PURE__*/createIcon(dataCloudUploadSolid)
export default IconCloudUploadSolid
